import React from "react"

import StoryblokImage from "../../internal/storyblokImage/StoryblokImage"
import * as styles from "./EventCard.module.scss"

function padTo2Digits(num) {
  return num.toString().padStart(2, '0');
}

function getFullMonth(month){
  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  return months[month];
}

const formateDate = (dateString) => {
  return[
    padTo2Digits(dateString.getDate()),
    getFullMonth(dateString.getMonth()),
    padTo2Digits(dateString.getFullYear()),
  ].join(' ')
}

const EventCard = ({ headline, date, endDate, image, thumbnail, excerpt, cta_text, cta_link, location }) => {
  let img;
  if(thumbnail && (thumbnail.filename !== "" && thumbnail.filename !== null)){
    img = thumbnail;
  }else if(image &&(image.filename !== "" && image.filename !== null)){
    img = image
  }else{
    img = null
  }

  return (
    <div className={`panel-radius shadow-cards ${styles.wrapper}`}>
      <div className={styles.image_wrapper}>
      {<StoryblokImage sbImageData={img} cropWidth={546} cropHeight={150}/>}
      <div className={styles.link_overlay}>
        <a href={cta_link}></a>
      </div>
      </div>
      <div className={styles.content}>
        <div className={styles.label}>
          {(date && endDate) && (date !== endDate) ? (
            <span>{formateDate(new Date (date.replace(/-/g, "/")))} - {formateDate(new Date (endDate.replace(/-/g, "/")))}</span>
            ) : date ? (
            <span>{formateDate(new Date (date.replace(/-/g, "/")))}</span>
            ) : null}
          {date && location ? ' | ' : null}
          {location ? <span>{location}</span>: null}
        </div>
        {headline ? <div className={styles.title}>{headline}</div> : null}
        {excerpt ? <p>{excerpt}</p> : null}
        {cta_text ? (
          <div className={styles.cta}>
            <a href={cta_link || "#"}>{cta_text}</a>
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default EventCard